import { connectToStores } from 'fluxible-addons-react';
import { QUANTUM_UI } from '../../../../flags';
import DocumentStore from '../../../stores/DocumentStore';
import NavigationStore from '../../../stores/NavigationStore';
import { ApiExplorer } from './ApiExplorer';
import { ApiExplorer as ApiExplorerOld } from './ApiExplorer.old';
var ApiExplorerComponent = QUANTUM_UI ? ApiExplorer : ApiExplorerOld;
export default connectToStores(ApiExplorerComponent, [DocumentStore, NavigationStore], function (context, props) {
    var url = props.currentRoute.url;
    var doc = context.getStore(DocumentStore).getDocument(url);
    return { doc: doc };
});
